import type { IPaginationLinks } from '../models/pagination-links.model';

export default class PaginationLinksApiModel {
  public static mapToBusinessModel(apiModel: PaginationLinksApiModel): IPaginationLinks {
    return {
      previous: apiModel.previous,
      next: apiModel.next,
      current: apiModel.current,
    };
  }

  public previous!: string;
  public next!: string;
  public current!: string;
}
